import { render, staticRenderFns } from "./ExhibitionPage.vue?vue&type=template&id=614a4b30&scoped=true&"
import script from "./ExhibitionPage.vue?vue&type=script&lang=js&"
export * from "./ExhibitionPage.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitionPage.vue?vue&type=style&index=0&id=614a4b30&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614a4b30",
  null
  
)

export default component.exports